const MENU_BAR = [
    { company: "Axgura", link:"/#" },
    { company: "DevSensor", link: "https://devsensor.com" },
    { company: "IStar", link: "https://aesthery.com" },
    { company: "Axion", link: "/#" }
];

export default MENU_BAR;